export default {
    name: 'login',
    data() {
        return {

        }
    },

    methods: {



    },

    mounted() {
        const that = this;

    }
}